import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/EmissionControlChallengesHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-28.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ecs2 { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO (no border-top) ══ */
  .ecs2-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .ecs2-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .ecs2-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .ecs2-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ecs2-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .ecs2-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .ecs2-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .ecs2-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ecs2-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .ecs2-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .ecs2-bc-item:hover { color: #EB2019; }
  .ecs2-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .ecs2-bc-sep img { width: 24px; height: 24px; display: block; }
  .ecs2-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .ecs2-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .ecs2-main-section { padding: 80px 0 120px 0; }
  .ecs2-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .ecs2-article { flex: 1; min-width: 0; }

  .ecs2-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .ecs2-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .ecs2-meta-item:last-child { border-right: none; padding-right: 0; }
  .ecs2-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .ecs2-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .ecs2-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .ecs2-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ecs2-article-body p { margin-bottom: 20px; }
  .ecs2-article-body p:last-child { margin-bottom: 0; }

  .ecs2-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  .ecs2-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 0px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .ecs2-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .ecs2-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ecs2-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .ecs2-article-body ul li > span { flex: 1; }

  .ecs2-article-body strong { font-weight: 600; color: #202020; }

  .ecs2-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .ecs2-red-link:hover { opacity: 0.8; }

  /* Hashtags */
  .ecs2-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .ecs2-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .ecs2-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .ecs2-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .ecs2-nav-btn:hover { color: #EB2019; }
  .ecs2-nav-btn img { width: 40px; height: 40px; display: block; }

  .ecs2-share-icons { display: flex; align-items: center; gap: 20px; }
  .ecs2-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .ecs2-share-icon:hover { opacity: 0.85; }
  .ecs2-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .ecs2-sidebar { flex: 0 0 475px; }
  .ecs2-sidebar-block { margin-bottom: 60px; }
  .ecs2-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .ecs2-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .ecs2-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .ecs2-recent-item:hover .ecs2-recent-title { color: #EB2019; }
  .ecs2-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .ecs2-recent-body { flex: 1; min-width: 0; }
  .ecs2-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .ecs2-social-icons { display: flex; align-items: center; gap: 30px; }
  .ecs2-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .ecs2-social-icon:hover { opacity: 0.8; }
  .ecs2-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ecs2-hero             { height: 350px; }
    .ecs2-hero-content     { padding: 0 32px; }
    .ecs2-hero-title       { font-size: 30px; }
    .ecs2-hero-divider     { width: 100%; max-width: 479px; }
    .ecs2-breadcrumb       { padding: 24px 0 0 0; }
    .ecs2-breadcrumb-inner { padding: 0 32px; }
    .ecs2-inner            { padding: 0 32px; }
    .ecs2-main-section     { padding: 48px 0 60px 0; }
    .ecs2-main-row         { flex-direction: column; gap: 48px; }
    .ecs2-sidebar          { flex: none; width: 100%; }
    .ecs2-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ecs2-hero             { height: 360px; }
    .ecs2-hero-content     { padding: 0 16px; }
    .ecs2-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .ecs2-hero-divider     { width: 100%; }
    .ecs2-hero-subtitle    { font-size: 14px; }
    .ecs2-breadcrumb       { padding: 30px 0 0 0; }
    .ecs2-breadcrumb-inner { padding: 0 16px; }
    .ecs2-bc-item          { font-size: 14px; gap: 14px; }
    .ecs2-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ecs2-bc-sep img       { width: 22px; height: 22px; }
    .ecs2-inner            { padding: 0 16px; }
    .ecs2-main-section     { padding: 30px 0 60px 0; }
    .ecs2-main-row         { flex-direction: column; gap: 60px; }
    .ecs2-sidebar          { flex: none; width: 100%; }
    .ecs2-article-title    { font-size: 20px; margin-bottom: 15px; }
    .ecs2-article-body     { font-size: 14px; }
    .ecs2-article-body p   { margin-bottom: 15px; }
    .ecs2-article-body ul  { margin: 0 0 20px 0; gap: 10px; }
    .ecs2-article-body ul li { font-size: 14px; }
    .ecs2-meta-item        { font-size: 14px; }
    .ecs2-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .ecs2-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .ecs2-h3               { font-size: 14px; margin: 15px 0 0px 0; }
    .ecs2-nav-btn img      { width: 24px; height: 24px; }
    .ecs2-nav-btn          { font-size: 14px; }
    .ecs2-share-icon img   { width: 34px; height: 34px; }
    .ecs2-sidebar-title    { font-size: 20px; }
    .ecs2-hashtags         { margin-top: 30px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function EmissionControlSystemsIndustrialChallengesSolutions() {
  return (
    <div className="ecs2">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="ecs2-hero">
        <img className="ecs2-hero-bg" src={HeroBgImg} alt="Emission Control Challenges Hero" />
        <div className="ecs2-hero-overlay" />
        <div className="ecs2-hero-content">
          <h1 className="ecs2-hero-title">
            Emission Control Systems for Industrial Applications: Challenges and Solutions
          </h1>
          <hr className="ecs2-hero-divider" />
          <p className="ecs2-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="ecs2-breadcrumb" aria-label="Breadcrumb">
        <div className="ecs2-breadcrumb-inner">
          <a href="/" className="ecs2-bc-item">Home</a>
          <span className="ecs2-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="ecs2-bc-item">News &amp; Updates</a>
          <span className="ecs2-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ecs2-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="ecs2-main-section">
        <div className="ecs2-inner">
          <div className="ecs2-main-row">

            {/* ── ARTICLE ── */}
            <article className="ecs2-article">

              {/* Meta bar */}
              <div className="ecs2-meta-bar">
                <span className="ecs2-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="ecs2-meta-item"><img src={CalendarIcon} alt="date" /> January 24, 2025</span>
                <span className="ecs2-meta-item"><img src={ClockIconImg} alt="time" /> 7:09 am</span>
                <span className="ecs2-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="ecs2-article-title">
                Emission Control Systems for Industrial Applications: Challenges and Solutions
              </h1>

              {/* Body */}
              <div className="ecs2-article-body">

                <p>As industries aspire to fulfill rising energy needs and environmental regulations, controlling emissions has become crucial. An emission control system is essential for reducing pollutants released into the atmosphere and ensuring industrial compliance with global environmental standards. However, implementing such a system comes with its challenges.</p>

                {/* Article image */}
                <img className="ecs2-article-img" src={ArticleImg} alt="Emission Control Systems Industrial" />

                <p>Devoted to global decarbonization, Ador's expertise in emission control technologies manages the critical challenges enterprises encounter today.</p>

                <span className="ecs2-h2">Understanding Emission Control Systems</span>

                <p>An emission control system is a technology or a blend of technologies designed to decrease toxic emissions created during industrial functions. These systems are essential for altering the release of greenhouse gases (GHGs), particulate matter, and other impurities, guaranteeing cleaner and more sustainable surroundings.</p>

                <span className="ecs2-h2">Challenges in Executing Emission Control Systems</span>

                <p>While the advantages of these control systems are unquestionable, enterprises face several challenges when embracing these technologies:</p>

                <span className="ecs2-h3"> 1. High Initial Costs</span>
                <p>Advanced control systems require significant capital investment, particularly for heavy industries like steel production, cement manufacturing, and hydrogen generation. Many businesses need help to justify the upfront costs despite long-term savings and environmental benefits.</p>

                <span className="ecs2-h3"> 2. Energy Consumption</span>
                <p>Emission control technologies often consume additional energy, increasing overall energy costs. Balancing emissions reduction with energy efficiency becomes a key concern for industries aiming to optimize costs.</p>

                <span className="ecs2-h3"> 3. Complex Integration</span>
                <p>Integrating modern emission control technologies with existing legacy systems can be complex for industries. This integration requires careful planning, engineering, and ongoing maintenance to ensure compatibility and efficiency.</p>

                <span className="ecs2-h3"> 4. Stricter Regulations</span>
                <p>Growing environmental laws require enterprises to improve their systems consistently to remain compliant. Fulfilling these necessities while maintaining operational efficiency offers a substantial challenge.</p>

                <span className="ecs2-h3"> 5. Equipment Maintenance</span>
                <p>These control systems need frequent maintenance to operate effectively. Ignoring maintenance can lead to inefficiencies and inflated downtime, negatively impacting productivity.</p>

                <span className="ecs2-h2">Solutions for Adequate Emission Control</span>

                <p>Industries must adopt innovative solutions tailored to their needs to address these challenges. Ador's expertise in emission management provides several effective strategies:</p>

                <span className="ecs2-h3"> 1. Advanced Power Conversion Technologies</span>
                <p>Ador specializes in power conversion units designed to enhance the efficiency of hydrogen generation systems. Integrating Alkaline, PEM, SOEC, and AEM electrolysers minimizes power consumption and reduces emissions during production processes.</p>

                <span className="ecs2-h3"> 2. Modular Emission Control Systems</span>
                <p>Modular designs allow businesses to scale their systems based on operational requirements. This design approach reduces initial costs and ensures flexibility for future upgrades.</p>

                <span className="ecs2-h3"> 3. IoT and Automation Integration</span>
                <p>Industries can monitor and manage emissions in real time by incorporating IoT and automated systems. Automatic alerts for maintenance and performance optimization decrease downtime and improve operational efficiency.</p>

                <span className="ecs2-h3"> 4. Renewable Energy Integration</span>
                <p>Incorporating emission control systems with renewable energy sources such as solar and wind power can significantly decrease energy expenses and environmental effects. <strong>Ador's 500-MW manufacturing facility</strong> for hydrogen power sources exemplifies how renewable energy can push sustainable solutions.</p>

                <span className="ecs2-h3"> 5. Compliance and Monitoring Tools</span>
                <p>Industries benefit from tools that monitor and document emissions compliance to navigate stringent regulations. Ador's emission control solutions have regulatory tracking systems to ensure adherence to evolving standards.</p>

                <span className="ecs2-h2">Integration of AI and Machine Learning</span>

                <p>The incorporation of Artificial Intelligence (AI) and Machine Learning (ML) into emission control systems is transforming industrial environmental management. These technologies enable predictive analytics, allowing for real-time monitoring and forecasting of emission levels. By analyzing historical data and identifying patterns, AI-driven systems can proactively adjust operations to minimize emissions, enhance system efficiency, and reduce the risk of non-compliance with environmental regulations. This proactive approach not only ensures adherence to standards but also optimizes operational performance.</p>

                <span className="ecs2-h2">Adoption of Carbon Capture and Storage (CCS)</span>

                <p>Carbon Capture and Storage (CCS) technologies are gaining traction as effective solutions for reducing greenhouse gas emissions in industrial settings. CCS involves capturing carbon dioxide emissions produced from industrial processes and storing them underground or utilizing them in other applications. Implementing CCS can significantly lower the carbon footprint of industries, aiding in the fight against climate change. Moreover, integrating CCS with existing emission control systems can enhance overall environmental performance and sustainability.</p>

                <span className="ecs2-h2">Embracing Renewable Energy Sources</span>

                <p>Integrating renewable energy sources, such as solar and wind power, into industrial operations is a strategic move toward sustainable emission control. Utilizing clean energy reduces reliance on fossil fuels, thereby decreasing the overall emissions associated with industrial activities. Additionally, renewable energy integration can lead to cost savings in the long term and demonstrate a company's commitment to environmental stewardship. This transition not only supports global sustainability goals but also positions industries as leaders in environmental responsibility.</p>

                <span className="ecs2-h2">Industries Benefiting from these Control Systems</span>

                <span className="ecs2-h3">1.Hydrogen Generation</span>
                <p>With the rising demand for clean energy, hydrogen generation processes need robust emission control solutions. Ador's power conversion units ensure low-emission hydrogen production, aligning with global decarbonization goals.</p>

                <span className="ecs2-h3">2.Manufacturing and Heavy Industries</span>
                <p>From cement production to steel plants, control systems decrease particulate matter and greenhouse gas emissions, guaranteeing adherence to strict environmental laws.</p>

                <span className="ecs2-h3">3.Energy Sector</span>
                <p>Power plants utilizing fossil fuels rely on emission control technologies like scrubbers and catalytic converters to minimize pollutants and boost purer energy generation.</p>

                <span className="ecs2-h3">4.Automotive Industry</span>
                <p>Emission control systems, including catalytic converters and diesel particulate filters, are critical for meeting automotive emission norms.</p>

                <span className="ecs2-h2">The Future of Emission Control Systems</span>

                <p>As industries evolve, so will the technologies driving emission control. Emerging trends include:</p>

                <ul>
                  <li><span><strong>AI and Machine Learning:</strong> Leveraging data for predictive maintenance and improved efficiency.</span></li>
                  <li><span><strong>Carbon Capture and Storage (CCS):</strong> Cutting-edge systems to catch and hold CO2 emissions.</span></li>
                  <li><span><strong>Hybrid Systems:</strong> Integrating traditional emission controls with renewable energy for optimized performance.</span></li>
                </ul>

                <span className="ecs2-h2">Ador: A Leader in Emission Control Solutions</span>

                <p>With over a century of expertise in <strong>power electronics</strong> and advanced technologies, Ador is committed to driving sustainable industrial practices. Our state-of-the-art facilities in Pune and a dedicated <strong>500-MW manufacturing facility</strong> for hydrogen power sources make us a trusted enterprise associate worldwide.</p>

                <span className="ecs2-h2">In Essence</span>

                <p>Executing emission control systems is no longer optional—it's essential for enterprises looking to remain competitive and environmentally accountable. While challenges exist, inventive solutions like those delivered by Ador ensure that companies can overcome them efficiently.</p>

                <p>Industries can balance productivity and sustainability by integrating air injection systems, optimizing the combustion process, and implementing exhaust gas recirculation (EGR) systems to reduce exhaust emissions. Advanced control of air-fuel mixtures, positive crankcase ventilation (PCV) valves, and engine exhaust treatment technologies help minimize hydrocarbons, carbon monoxide, and other pollutants.</p>

                <p>Additionally, managing emissions at the source, such as the fuel tank and carburetor, and improving internal combustion engine performance through better combustion chamber design and high-temperature efficiency, ensures cleaner operation. By enhancing the exhaust system and leveraging gas recirculation (EGR) systems to reduce exhaust gases, industries can achieve optimal engine efficiency while meeting regulatory standards. Effective evaporative emissions control further minimizes fuel vapor emissions, while reducing carbon dioxide output contributes to lower greenhouse gas emissions and environmental sustainability.</p>

                <p>With Ador's cutting-edge solutions, businesses can implement these technologies effectively, ensuring compliance while maintaining operational excellence</p>

                <p>Ready to optimize your operations and decrease emissions? <a href="/contact-us" className="ecs2-red-link">Contact us</a> today to explore cutting-edge control system solutions.</p>

                <p className="ecs2-hashtags">#EmissionControlSystem #SustainableIndustries #PowerElectronics #Decarbonization #CleanEnergy</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="ecs2-bottom-row">
                <div className="ecs2-bottom-nav">
                  <a href="/news/how-esp-improve-air-quality-industrial-settings" className="ecs2-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/how-switch-mode-power-supply-improves-energy-efficiency" className="ecs2-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="ecs2-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/emission-control-systems-for-industrial-applications-challenges-and-solutions/" className="ecs2-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Femission-control-systems-for-industrial-applications-challenges-and-solutions%2F&mode=login" className="ecs2-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Femission-control-systems-for-industrial-applications-challenges-and-solutions%2F%26title%3DEmission%2520Control%2520System%2520for%2520Industrial%2520Applications%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Femission-control-systems-for-industrial-applications-challenges-and-solutions%2F" className="ecs2-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="ecs2-sidebar">

              {/* Recent Posts */}
              <div className="ecs2-sidebar-block">
                <p className="ecs2-sidebar-title">Recent Posts</p>
                <div className="ecs2-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="ecs2-recent-item">
                      <img src={post.img} alt={post.title} className="ecs2-recent-img" />
                      <div className="ecs2-recent-body">
                        <span className="ecs2-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="ecs2-sidebar-block">
                <p className="ecs2-sidebar-title">Social Media</p>
                <div className="ecs2-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="ecs2-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ecs2-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}